"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
var _ref = {},
    toString = _ref.toString;

function isObject(obj) {
  return toString.call(obj) === '[object Object]';
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ0b1N0cmluZyIsImlzT2JqZWN0Iiwib2JqIiwiY2FsbCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2lzT2JqZWN0LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHsgdG9TdHJpbmcgfSA9IHt9O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBpc09iamVjdChvYmopIHtcbiAgcmV0dXJuIHRvU3RyaW5nLmNhbGwob2JqKSA9PT0gJ1tvYmplY3QgT2JqZWN0XSc7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLFdBQXFCLEVBQXJCO0FBQUEsSUFBUUEsUUFBUixRQUFRQSxRQUFSOztBQUVlLFNBQVNDLFFBQVQsQ0FBa0JDLEdBQWxCLEVBQXVCO0VBQ3BDLE9BQU9GLFFBQVEsQ0FBQ0csSUFBVCxDQUFjRCxHQUFkLE1BQXVCLGlCQUE5QjtBQUNEIn0=